// extracted by mini-css-extract-plugin
module.exports = {"navArrow":"qk","navArrowSvg":"ql","wrapper":"qm","reverse":"qn"};